/* ----------------------------------------------------------------------------
build an "on this page" list from the headings of the current article
---------------------------------------------------------------------------- */
export default class TableOfContents extends HTMLElement {
	connectedCallback() {
		const target = this.getAttribute('target');
		const scope = target ? document.getElementById(target) : document;
		const headings = Array.from(scope.querySelectorAll('h2')).filter(
			(heading) => heading.id,
		);

		// one section is not a table of contents
		if (headings.length < 2) {
			this.hidden = true;
			return;
		}

		const list = document.createElement('ul');
		for (const heading of headings) {
			const item = document.createElement('li');
			const link = document.createElement('a');
			link.className = 'button --menu --primary truncate';
			link.textContent = heading.textContent.trim();
			// the rail truncates with an ellipsis, so keep the full text reachable
			link.title = link.textContent;
			link.href = `#${heading.id}`;
			item.appendChild(link);
			list.appendChild(item);
		}

		const label = document.createElement('h2');
		label.textContent = 'On this page';
		this.replaceChildren(label, list);
	}
}

window.customElements.define('table-of-contents', TableOfContents);
